import { useEffect, useState } from 'react';
import logo from '@images/megalogo.png';
import top_bg from '@images/idea_top.png';
import { makeStyles } from '@mui/styles';
import { AspectRatio } from 'react-aspect-ratio';
import example from '@images/example.png';
import ic_menu from '@images/ic_menu.png';
import ic_tick from '@images/cccc.png';
import { format } from 'date-fns';
import Marquee from 'react-fast-marquee';
import edu_ic from '@images/scroll.png';
import PollPledgeIcon from '@components/modules/Poll/PollPledgeIcon';
import {
  getSumAPI,
  listIdea,
  listIdeaCategorys,
  listIdeaSupporters,
} from '@sdk/managers/IdeaManager';
import Loader from '@components/elements/Loader';
import { getImageUrl } from '@utils/image';
import { useHistory } from 'react-router-dom';
import { useAuth } from '@hooks/Auth';
const useStyles = makeStyles({
  cinput: {
    width: '100%',
    padding: ' 9px 15px 9px 20px',
    maxWidth: 700,
    borderRadius: 50,
    position: 'relative',
    zIndex: 99999999,
    border: 'none',
    marginTop: 20,

    fontSize: 22,
  },
  searchTitle: {
    fontSize: '2rem' /* 24px */,
    lineHeight: ' 2.5rem' /* 32px */,
    '@media (max-width: 768px)': {
      fontSize: ' 1.5rem' /* 24px */,
      lineHeight: ' 2rem' /* 32px */,
    },
  },

  tag: {
    '@media (max-width: 1280px)': {
      marginTop: '120px !important',
    },
  },
  prod: {
    width: '100%',
    minWidth: 120,
    borderRadius: 8,
    aspectRatio: 1.32,
    objectFit: 'cover',
  },
  prodContainer: {
    display: 'grid',
    position: 'relative',
    gridTemplateColumns: 'repeat(4, 1fr)',
    columnGap: '20px',
    rowGap: '40px',
    '@media (max-width: 1280px)': {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
    '@media (max-width: 920px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    // '@media (max-width: 400px)': {
    //   gridTemplateColumns: 'repeat(1, 1fr)',
    // },
  },
  cContainer: {
    width: '100%',
    position: 'relative',
    maxWidth: 1536,
  },
  cButton: {
    background: '#BD10E0',
    borderRadius: '27.5px',
    padding: '9px 28px',
    color: 'white',
    top: '50px',
    right: '-2vw',
    '@media (max-width: 1536px)': {
      right: 20,
    },
    '@media (max-width: 640px)': {
      top: 60,
    },
    position: 'absolute',
  },
  card: {
    padding: '34px 0',
  },
  topTitle: {
    opacity: 1,
    color: 'white',
    fontSize: '60px',
    lineHeight: '70px',
    fontWeight: 700,
    '@media (max-width: 640px)': {
      fontSize: '18px',
      lineHeight: '20px',
    },
  },
  topContent: {
    '@media (max-width: 640px)': {
      fontSize: '14px',
      lineHeight: '16px',
    },
  },
  content: {
    width: '100%',
    position: 'relative',
    maxWidth: 1536,
    padding: 40,
    paddingBottom: 200,
    '@media (max-width: 640px)': {
      padding: 20,
      paddingBottom: 150,
    },
  },
  prodTime: {
    fontSize: 18,
    fontWeight: 700,
    height: 54,
    display: ' -webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginTop: 10,
    color: 'black',
    '@media (max-width: 768px)': {
      fontSize: 18,
    },
    '@media (max-width: 400px)': {
      height: 54,
      fontSize: 14,
    },
  },
  sort: {
    borderRadius: 8,
    border: '2px solid rgba(155,155,155, 1)',
    opacity: 1,
    maxWidth: 450,
    width: '100%',
    height: 80,
    padding: '0 10px',
    fontSize: 28,
    fontWeight: 700,
    '@media (max-width: 768px)': {
      height: 50,
      fontSize: 18,
    },

    // backgroundImage: `url(${arrown})`,
    // backgroundRepeat: 'no-repeat',
    // backgroundPosition: ' 98% center',
  },
  prodTitle: {
    fontSize: 28,
    fontWeight: 700,
    marginTop: 10,
    wordBreak: 'break-all',
    color: 'black',
    '@media (max-width: 768px)': {
      fontSize: 18,
    },
    '@media (max-width: 400px)': {
      fontSize: 14,
    },
  },
  furetureTitle: {
    fontSize: 40,
    lineHeight: '47px',
    fontWeight: 700,
    marginBottom: 20,

    '@media (max-width: 768px)': {
      fontSize: 28,
    },
    '@media (max-width: 400px)': {
      fontSize: 18,
    },
  },
  topCard: {
    marginTop: 200,
    border: '3px solid #FEC411',
    boxShadow: '10px 8px 0px 2px #FEC411',
    background: 'black',
    borderRadius: 4,
    transition: 'all 0.5s',
    color: 'white',
    '@media (max-width: 640px)': {
      marginTop: 50,
    },
  },
  sponsor: {
    borderRadius: ' 3px',
    border: '2px solid rgba(254,196,17, 1)',
    boxShadow: '5px -6px 0px rgba(254,196,17, 1)',
    opacity: 1,
    backgroundColor: 'rgba(255,255,255, 1)',
    position: 'fixed',
    height: 'max-content',
    left: 40,
    right: 40,
    bottom: 40,
    padding: '20px 55px',
    gap: 55,
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 1336px)': {
      bottom: 100,
    },
    '@media (max-width: 640px)': {
      left: 20,
      right: 20,
      padding: '20px 20px',
      gap: 20,
    },
  },
  sponsorItem: {
    cursor: 'pointer',
    width: 124,
    height: 124,
    minWidth: 124,
    margin: '0 20px',

    '@media (max-width: 640px)': {
      width: 60,
      minWidth: 60,
      height: 60,
    },
  },
  sponContainer: {
    overflowY: 'hidden',
    gap: 60,
    '@media (max-width: 640px)': {
      gap: 20,
      bottom: 100,
    },
  },
});

const ListIdea = () => {
  const classes = useStyles();
  const [categories, setCategories] = useState<
    { title: string; id: string }[] | undefined
  >();
  const [selectCategory, setSelectCategory] = useState<any>();
  const { dbUser } = useAuth();
  const history = useHistory();
  const [list, setList] = useState<any[]>();
  const [search, setSearch] = useState('');
  const [info, setInfo] = useState({ ideas: 0, pledges: 0, sponsors: 0 });
  const [sort, setSort] = useState(1);
  const [suppoters, setSuppoters] = useState([]);
  const [hideNav, setHideNav] = useState(window.screen.width >= 1280);
  useEffect(() => {
    const el = document.getElementsByTagName('nav');
    if (el?.length) {
      el[0].style.display = hideNav ? 'none' : 'flex';
    }
  }, [hideNav]);

  const sortPoll = (a, b) => {
    switch (sort) {
      case 2:
        // console.log(voteTotal(b), voteTotal(a));
        return a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 1;
      case 3:
        // console.log(voteTotal(b), voteTotal(a));
        return b.title.toLowerCase() < a.title.toLowerCase() ? -1 : 1;

      default:
        return 1;
    }
  };
  const navigateUrl = (url: string) => {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    } else {
      return 'http://' + url;
    }
  };
  const getSupporter = async () => {
    try {
      const res = (await listIdeaSupporters([
        { items: ['logo { key bucket region }', 'url', 'id'] },
      ])) as any;
      for (let i = 0; i < (res?.data?.result?.items?.length || 0); i++) {
        res.data.result.items[i].logo = await getImageUrl(
          res.data.result.items[i].logo
        );
      }
      console.log(res?.data?.result?.items);
      setSuppoters(res?.data?.result?.items || []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCategory = async () => {
    try {
      const res = (await listIdeaCategorys(
        [{ items: ['title', 'id'] }],

        {
          filter: {
            edu: {
              eq: true,
            },
          },
        }
      )) as any;

      setCategories(res?.data?.result?.items || []);
    } catch (error) {
      console.log(error);
    }
  };

  const getListIdea = async () => {
    try {
      const res = (await listIdea([
        {
          items: [
            'id',
            'title',
            'category',
            'startTime',
            'endTime',
            'hashtag',
            'image { key bucket region }',
            'featured',
            'createdAt',
          ],
        },
      ])) as any;
      const listData = res?.data?.result.items;
      for (let i = 0; i < listData.length; i++) {
        const item = listData[i];
        if (item.image) {
          listData[i].image = await getImageUrl(item.image);
        }
      }
      // const items = (res?.data?.result.items || []).map(async (item) => {
      //   if (item.image) {
      //     item.image = {
      //       ...item.image,
      //       url: await getImageUrl(item.image),
      //     };
      //   }
      //   console.log(item);
      //   return item;
      // });
      setList(
        listData.filter((item) => +new Date() <= +new Date(item.endTime))
      );
    } catch (error) {
      console.log(error);
    }
  };
  const getSum = async () => {
    try {
      const res = (await getSumAPI()) as any;
      const data = res?.data?.result;
      if (data && JSON.parse(data)?.statusCode === 200) {
        setInfo(JSON.parse(data).body);
      }
      // setInfo(
      //   JSON.parse(
      //     res?.data?.result
      //       ? JSON.parse(res?.data?.result)?.body || {
      //           ideas: 0,
      //           pledges: 0,
      //           sponsors: 0,
      //         }
      //       : { ideas: 0, pledges: 0, sponsors: 0 }
      //   )
      // );
    } catch (error) {}
  };
  useEffect(() => {
    getCategory();
    getSupporter();
    getSum();
    return () => {
      const el = document.getElementsByTagName('nav');
      if (el?.length) {
        el[0].style.display = 'flex';
      }
    };
  }, []);
  useEffect(() => {
    if (categories) {
      getListIdea();
    }
  }, [categories]);
  console.log(list);

  if (!categories || !list)
    return <Loader spinnerCn="bg-white" title="Fetching Idea list..." />;
  return (
    <div className="idea-list bg-white flex flex-col items-center justify-start w-full">
      <div
        className="text-center flex flex-col items-center justify-start w-full bg-cover px-5"
        style={{
          background: `url(${top_bg})`,
          transition: 'all 0.5s',
          paddingBottom: !!search ? 20 : 50,
        }}
      >
        <div className={classes.cContainer}>
          {(dbUser?.type === 'STAFF' || !!dbUser?.email?.includes('.edu.')) && (
            <button
              className={classes.cButton}
              onClick={() => {
                history.push('/idea/create');
              }}
            >
              + Tertiary Project
            </button>
          )}
          <img
            src={ic_menu}
            onClick={() => setHideNav(!hideNav)}
            alt=""
            className=" mx-auto hidden xl:flex "
            style={{
              width: 30,
              height: 20,
              marginRight: 10,
              position: 'absolute',
              left: 100,
              top: 100,
              cursor: 'pointer',
            }}
          />
          <div
            style={{ marginTop: '49px', width: 300 }}
            className=" mx-auto hidden xl:flex relative"
          >
            <img
              src={logo}
              className=" mx-auto hidden xl:flex "
              style={{ marginTop: '49px', width: 300 }}
              alt="logo"
              onClick={() => history.push('/home')}
            />
          </div>

          <div
            className={`${classes.tag} flex flex-wrap items-center justify-center gap-x-2 gap-y-4  w-full text-sm md:text-2xl`}
            style={{
              flexWrap: 'wrap',
              marginTop: 50,
              columnGap: 20,
              padding: '0 20px',
            }}
          >
            {categories.map((item) => (
              <div
                onClick={() => {
                  setSelectCategory(
                    selectCategory === item.title ? undefined : item.title
                  );
                }}
                style={{
                  background:
                    selectCategory === item.title ? 'orange' : 'white',
                  color: selectCategory === item.title ? 'white' : 'black',
                  padding: '3px 21px',
                  borderRadius: '22px',
                  cursor: 'pointer',
                  fontSize: '1rem',
                }}
                key={item.id}
              >
                {item.title}
              </div>
            ))}
          </div>
          <p
            className={classes.searchTitle + ' text-white text-2xl font-bold'}
            style={{ marginTop: 50 }}
          >
            Support the world’s best ideas today
          </p>
          <input
            className={classes.cinput}
            type="search"
            placeholder="Search..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
          <div>
            <div
              className={classes.topCard}
              style={!!search ? { marginTop: 10 } : {}}
            >
              <div
                className={`${classes.card} p-4 text-center flex flex-wrap justify-around items-center`}
              >
                <div>
                  <div className={classes.topTitle}>{info.ideas}</div>
                  <div className={classes.topContent + ' text-2xl font-bold'}>
                    Ideas Realized
                  </div>
                </div>
                <div>
                  <div className={classes.topTitle}>{info.pledges}</div>
                  <div className={classes.topContent + ' text-2xl font-bold'}>
                    Pledges Garnered
                  </div>
                </div>
                <div>
                  <div className={classes.topTitle}>
                    {suppoters?.length || 0}
                  </div>
                  <div className={classes.topContent + ' text-2xl font-bold'}>
                    Sponsors
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.content}>
        <select
          className={classes.sort}
          onChange={(e) => {
            setSort(+e.target.value || 0);
          }}
        >
          <option value={1}>Latest</option>
          <option value={2}>A-Z polls</option>
          <option value={3}>Z-A Polls</option>
        </select>
        <div
          style={{
            marginTop: 30,
            padding: ' 25px',
            border: '3px solid #9013FE',
            boxShadow: '10px 8px 0px 2px #9013FE',
            background: '#F8E71C',
            borderRadius: 4,
          }}
        >
          {' '}
          <div className={classes.furetureTitle} style={{ color: '#BD10E0' }}>
            Featured Pledges
          </div>
          {(!list ||
            !list.filter(
              (item) =>
                item.featured &&
                (!selectCategory || item.category === selectCategory) &&
                (!search ||
                  item.title.includes(search) ||
                  ('#' + item.hashtag).includes(search))
            ).length) && (
            <h3
              style={{
                color: 'black',
                textAlign: 'center',
                paddingBottom: 50,
                width: '100%',
                fontSize: 30,
              }}
            >
              No Pledges Available
            </h3>
          )}
          <div className={classes.prodContainer + ' flex-wrap'}>
            {list
              .filter(
                (item) =>
                  item.featured &&
                  (!selectCategory || item.category === selectCategory) &&
                  (!search ||
                    item.title.includes(search) ||
                    ('#' + item.hashtag).includes(search))
              )
              .sort(sortPoll)
              .map((item) => (
                <div
                  key={item.id}
                  style={{ cursor: 'pointer', position: 'relative' }}
                  onClick={() => {
                    history.push('/idea/' + item.id);
                  }}
                >
                  <div className="relative">
                    <div
                      className="absolute z-1  flex items-center"
                      style={{ right: 5, bottom: 0 }}
                    >
                      <img
                        src={edu_ic}
                        alt=""
                        className="w-12 h-12"
                        style={{
                          position: 'absolute',
                          bottom: 0,
                          right: 0,
                          transform: 'translate(-110%,10%)',
                        }}
                      />
                      <div className="w-12 h-12">
                        <PollPledgeIcon color="animated" />
                      </div>
                    </div>
                    <img
                      src={item.image || 'image'}
                      className={classes.prod}
                      alt="example"
                    />
                  </div>

                  <div
                    className={classes.prodTitle}
                    style={{
                      position: 'relative',
                      marginTop: 10,
                    }}
                  >
                    <img
                      style={{
                        display: 'inline',
                        width: 25,
                      }}
                      src={ic_tick}
                      alt="icon_tick1"
                    />
                    &nbsp; &nbsp;
                    {item.title}
                  </div>
                  <div
                    style={{
                      color: 'grey',
                      textAlign: 'center',
                      width: '100% !important',
                      marginTop: 5,
                    }}
                    className={classes.prodTime}
                  >
                    Starts &nbsp;
                    <span className="font-bold">
                      {format(new Date(item.startTime), 'dd MMM')}
                    </span>{' '}
                    | Ends{' '}
                    <span className="font-bold">
                      {format(new Date(item.endTime), 'dd MMM')}
                    </span>
                  </div>
                </div>
              ))}
          </div>
        </div>
        {(!list ||
          !list.filter(
            (item) =>
              !item.featured &&
              (!selectCategory || item.category === selectCategory) &&
              (!search ||
                item.title.includes(search) ||
                ('#' + item.hashtag).includes(search))
          ).length) && (
          <h3
            style={{
              color: 'black',
              width: '100%',
              textAlign: 'center',

              padding: '100px 0',
              fontSize: 30,
            }}
          >
            No Pledges Available
          </h3>
        )}
        <div
          className={classes.prodContainer + ' flex-wrap'}
          style={{
            padding: '50px 25px',
          }}
        >
          {list
            .filter(
              (item) =>
                !item.featured &&
                (!selectCategory || item.category === selectCategory) &&
                (!search ||
                  item.title.includes(search) ||
                  ('#' + item.hashtag).includes(search))
            )
            .sort(sortPoll)
            .map((item, i) => (
              <div
                key={item.id}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  history.push('/idea/' + item.id);
                }}
              >
                <div className="relative">
                  <div
                    className="absolute z-1 flex items-center"
                    style={{ right: 5, bottom: 0 }}
                  >
                    <img
                      src={edu_ic}
                      alt=""
                      className="w-12 h-12 "
                      style={{
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                        transform: 'translate(-110%,10%)',
                      }}
                    />
                    <div className="w-12 h-12">
                      <PollPledgeIcon color="animated" />
                    </div>
                  </div>
                  <img
                    src={item.image || 'image'}
                    className={classes.prod}
                    alt="example"
                  />
                </div>
                <div
                  className={classes.prodTitle}
                  style={{
                    position: 'relative',
                    marginTop: 10,
                  }}
                >
                  <img
                    style={{
                      display: 'inline',
                      width: 25,
                    }}
                    src={ic_tick}
                    alt="icon_tick1"
                  />
                  &nbsp; &nbsp;
                  {item.title}
                </div>
                <div
                  style={{
                    color: '#8e8e8d',
                    textAlign: 'center',
                    width: '100% !important',
                    marginTop: 5,
                  }}
                  className={classes.prodTime}
                >
                  Starts &nbsp;
                  <span className="font-bold">
                    {format(new Date(item.startTime), 'dd MMM')}
                  </span>{' '}
                  | Ends{' '}
                  <span className="font-bold">
                    {format(new Date(item.endTime), 'dd MMM')}
                  </span>
                </div>
              </div>
            ))}
        </div>
      </div>

      <div className={classes.sponsor}>
        <div
          style={{
            color: '#BD10E0',
            fontSize: 32,
            lineHeight: 32,
            fontWeight: 700,
          }}
        >
          {window.screen.width >= 620 && (
            <p>
              {' '}
              MEGAXPOLL
              <br /> SPONSORS
            </p>
          )}
        </div>
        {suppoters.length && (
          <div
            style={{
              flex: 1,
              height: '100%',
            }}
            className={classes.sponContainer}
          >
            <Marquee speed={50} play={suppoters.length > 5}>
              {suppoters.map((item: any) => (
                <a
                  className={classes.sponsorItem}
                  key={item.id}
                  href={navigateUrl(item.url)}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={item.logo}
                    alt=""
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </a>
              ))}
            </Marquee>
          </div>
        )}
      </div>
    </div>
  );
};
export default ListIdea;
